/**
 * Claves de permisos granulares para modales RRHH.
 * Cada componente `*.component.ts` bajo modals/ tiene `modal.archivo.<nombre>.abrir` y `.gestionar` en el catálogo.
 * La ficha de empleado tiene además pestañas bajo `modal.empleado.ficha.pestania.*`.
 */
export const RRHH_MODAL_ARCHIVO = {
  abrir: (componentBaseName: string) => `modal.archivo.${componentBaseName}.abrir`,
  gestionar: (componentBaseName: string) => `modal.archivo.${componentBaseName}.gestionar`,
} as const;

/** Pestañas principales de la ficha del empleado (employee-file-modal). */
export const RRHH_MODAL_EMPLEADO_FICHA_PESTANIA = {
  personal: 'modal.empleado.ficha.pestania.personal',
  contacto: 'modal.empleado.ficha.pestania.contacto',
  contractual: 'modal.empleado.ficha.pestania.contractual',
  bancario: 'modal.empleado.ficha.pestania.bancario',
  epp: 'modal.empleado.ficha.pestania.epp',
  documentos: 'modal.empleado.ficha.pestania.documentos',
  hse: 'modal.empleado.ficha.pestania.hse',
  hseSubDocumentacion: 'modal.empleado.ficha.hse.sub.documentacion',
  hseSubSst: 'modal.empleado.ficha.hse.sub.sst',
  evaluaciones: 'modal.empleado.ficha.pestania.evaluaciones',
  historial: 'modal.empleado.ficha.pestania.historial',
} as const;
